export { MaterialModule } from './material.module';
export { getSpanishPaginatorIntl } from './spanish-paginator/spanish-paginator-intl';
export { getSpanishStepperIntl } from './spanish-stepper/spanish-stepper-intl';
